import { usePropertyTargetLoanRequest } from '../../../queries/PropertyFields/NonRentalCoreFields';
import { MoneyBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../components/ApplicationQuestionReviewItem';
import { formatCurrencyOrUndefined } from '@apply/ui';

interface TargetLoanRequestProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const TargetLoanRequest: React.FC<TargetLoanRequestProps> = ({ propertyGuid, required = false, isReview = false }) => {
    const label = 'Target Loan Request';
    const [targetLoanRequest, set_targetLoanRequest] = usePropertyTargetLoanRequest(propertyGuid);

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(Number(targetLoanRequest))}
                />
            ) : (
                <MoneyBox
                    id='targetLoanRequest'
                    allowNegative={false}
                    value={targetLoanRequest}
                    onChange={(value) => set_targetLoanRequest(value)}
                    label={label}
                    required={required}
                    displayChange={false}
                    min={100000}
                    max={5000000}
                />
            )}
        </>
    );
};
